import React, {useEffect,useState,useRef} from 'react'
import io from 'socket.io-client'
import './Styles/Chat.css'

// connecting as socket io client
const socket = io("ws://185.187.154.14:8080", {
  extraHeaders: {
    "my-custom-header": "abcd"
  }
});

export default function Chat() {
    // user input refs
    const nameRef = useRef()
    const messageRef = useRef()

    // update chatboard on message submits
    let [num_users,setnum_users] = useState(1)
    let [chatboard,setchatboard] = useState([{username:"Darius",usermessage:"Hey! thanks for checking out my profile, Leave a message and contact info below and I will get back to you ASAP"}])
    
    // on chat update do =>
    useEffect(()=>{
        socket.on('num_users',(users)=>{
            // console.log(users)
            setnum_users(num_users=users)
        })
        socket.on('chatupdate',(chat)=>{
            // increment users 
            // console.log(data)
            setchatboard(chatboard=chat)
            
        })
    })
       
    
    // submitting message to server io
    const submitMessage =()=>{
        let name = nameRef.current.value
        let message = messageRef.current.value
        
        // check if user info is blank
        if(name === "" || message === ""){
            const smiles = ["😀" ,"😃", "😄", "😁", "😆", "😅", "😂", "🤣","😊"]
            const body_parts = ["👋" ,"🤚" ,"🖐" ,"✋" ,"🖖" ,"🦴" ,"👀" ,"👁" ,"👅" ]
            const ranNum = Math.floor((Math.random()*smiles.length)+1)
            name = smiles[ranNum]
            message = body_parts[ranNum]
        }
        // console.log(`user: ${name} & message: ${message}`)
        socket.emit('message',{username:name,usermessage:message})
  }
    return (
        <div>
           
            <div className="container">
                <div className="border ">
                    <h1 className="bg-dark text-white p-3">Chat</h1>
                    <div className="h-75 ">
                    <p>* try disabling https if chat not working</p>
                    <p>connected users: {num_users}</p>
                        <form className="form-group text-center">
                            <div className=" chatboard border p-3 text-left" >
                                {/* mapping messages into chatboard */
                                    chatboard.map((message,index) =>{
                                        return(
                                            <div key={index} className="chat_bubble m-3 p-3 ">
                                            <div className="chat_bubble">
                                            <p><span style={{background:"#118ab2"}}className="text-white p-3 ">{message.username}</span></p><br/>
                                            <p>{message.usermessage}</p>

                                            </div>
                                            </div>
                                        )
                                        
                                    })

                                    }
                            </div>
                            <label htmlFor="name" className="mb-3">Name:</label>
                            <input required ref={nameRef}type="text" id="name" className="form-control mb-3"/>
                            <label htmlFor="message" className="mb-3">Message:</label>
                            <textarea required ref={messageRef} name="message" id="message" cols="30" rows="10" className="form-control"></textarea><br/>
                            <div  onClick={submitMessage} className="form-control btn btn-primary">Submit</div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
